const useRazorpayPayment = () => {
  const createOrder = async (amount) => {
    const res = await fetch("https://thebhavanasingh.com/create_order.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ amount: amount * 100 }),
    });

    const data = await res.json();
    if (!data?.id) throw new Error("Order creation failed");

    return data.id;
  };

  const payNow = async ({ courseType, formData, onSuccess }) => {
    if (!formData.name || !formData.email || !formData.phone) {
      alert("All fields are required");
      return;
    }

    const config = {
  online: { amount: 50000, desc: "Online Course" },
  offline: { amount: 100000, desc: "Offline Course" },
  offlineOnly: { amount: 200000, desc: "Only Offline Course" },
};


    const { amount, desc } = config[courseType];

    try {
      const orderId = await createOrder(amount);

      const options = {
        key: "rzp_live_meaLkJIwJaMl5q",
        amount: amount * 100,
        currency: "INR",
        name: "Bhavana Singh Courses",
        description: desc,
        order_id: orderId,
        prefill: formData,
        handler: onSuccess,
        theme: { color: "#3399cc" },
      };

      new window.Razorpay(options).open();
    } catch (err) {
      alert("Payment failed");
      console.error(err);
    }
  };

  return { payNow };
};

export default useRazorpayPayment;
